// @flow
import JobList from 'components/job/JobListContent';
import { connect } from 'react-redux';
import { fetchJobList, initialFetchJobList as initialFetchJobListAction } from 'actions/jobActions';

import type { JobFiltersSearchType } from 'types/JobFilter';
import type { DispatchType, StateType } from 'types/Actions';
import type { StateProps, DispatchProps } from 'components/job/JobListContent';

export default connect(
  (state: StateType): StateProps => ({
    jobs: state.jobListState.jobs,
    maxPage: state.jobListState.maxPage,
    totalJobs: state.jobListState.totalJobs,
    jobFilters: state.jobListState.jobFilters,
    status: state.jobListState.status,
  }),
  (dispatch: DispatchType): DispatchProps => ({
    initialFetchJobList: (filters?: JobFiltersSearchType) => dispatch(initialFetchJobListAction(filters)),
    fetchJobListPreview: (filters: JobFiltersSearchType) => dispatch(fetchJobList(filters)),
  })
)(JobList);
